const API_PATHS = {
  GET_SEARCH_RESULTS: 'api/search/',
}

export default class UserServiceApi {
  static async getSearchResponse(input, ACKO_DRIVE_ENDPOINT) {
    let result
    try {
      const response = await fetch(
        `${ACKO_DRIVE_ENDPOINT}/${API_PATHS.GET_SEARCH_RESULTS}?param=${encodeURIComponent(input)}`,
        {
          next: { revalidate: 0 },
          credentials: 'include',
        }
      )
      result = await response.json()
    } catch (ex) {
      console.log('user service error', ex)
    }
    return result
  }
}
